import theme from 'theme/theme';

const styles = {
    flex: {
        display: 'flex',
    },
    column: {
        display: 'block',
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 1,
        margin: '15px',
        minHeight: '175px',
    },
    cardContainer: {
        padding: '0',
    },
    card: {
        title: {
            fontSize: '1.3rem',
            textAlign: 'center',
        },
        week: {
            fontSize: '0.75rem',
            textAlign: 'center',
            marginBottom: '20px',
        },
        value: {
            fontSize: '1.75rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '20px',
        },
        bookings: {
            fontSize: '1rem',
            textAlign: 'center',
        },
    },
    brand: {
        red: theme.palette.accent1Color,
        green: theme.palette.primary1Color,
    },
    currencies: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '-35px',
    },
};

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/styles.js